'use strict';

/**
 *
 * @name: nownessApp.register
 *
 */

import RegisterDoubanFactory from './nn-register-douban.factory';
import RegisterLinkedinFactory from './nn-register-linkedin.factory';
import RegisterTwitterFactory from './nn-register-twitter.factory';
import RegisterWeiboFactory from './nn-register-weibo.factory';

const RegisterModule = angular
  .module('nownessApp.register', [])
  .factory('registerDb', RegisterDoubanFactory)
  .factory('registerLi', RegisterLinkedinFactory)
  .factory('registerTw', RegisterTwitterFactory)
  .factory('registerWb', RegisterWeiboFactory);

export default RegisterModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-register/nn-register.module.js